(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carlo-global-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('carlo-announcement-rotator')) {
  customElements.define('carlo-announcement-rotator', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.events?.abort();
    }

    initialize() {
      if (!this.isConnected) return;
      this.events?.abort();
      clearInterval(this.timer);
      this.messages = Array.from(this.querySelectorAll('[data-announcement-message]'));
      this.track = this.querySelector('.carlo-header__announcement-track');
      this.pauseButton = this.querySelector('[data-announcement-pause]');
      this.nextButton = this.querySelector('[data-announcement-next]');
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.delay = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.show(0);

      if (this.messages.length < 2) {
        this.pauseButton.hidden = true;
        this.nextButton.hidden = true;
        return;
      }

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.pauseButton.hidden = false;
      this.nextButton.hidden = false;
      this.updatePauseButton();

      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePauseButton();
        this.schedule();
      }, options);

      this.nextButton.addEventListener('click', () => {
        this.track.setAttribute('aria-live', 'polite');
        this.show((this.index + 1) % this.messages.length);
        this.schedule();
      }, options);

      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.schedule();
      }, options);

      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.schedule();
      }, options);

      this.track.addEventListener('focusin', () => {
        this.focused = true;
        this.schedule();
      }, options);

      this.track.addEventListener('focusout', () => {
        queueMicrotask(() => {
          this.focused = this.track.contains(document.activeElement);
          this.schedule();
        });
      }, options);

      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updatePauseButton();
        this.schedule();
      }, options);
      this.schedule();
    }

    show(index) {
      this.index = index;
      this.messages.forEach((message, position) => {
        const active = position === index;
        message.classList.toggle('is-active', active);
        message.setAttribute('aria-hidden', String(!active));
        message.inert = !active;
        if (message.tagName === 'A') {
          if (active) message.removeAttribute('tabindex');
          else message.setAttribute('tabindex', '-1');
        }
      });
    }

    updatePauseButton() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.track.setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }

    schedule() {
      clearInterval(this.timer);
      if (!this.isConnected || this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = setInterval(() => {
        this.track.setAttribute('aria-live', 'off');
        this.show((this.index + 1) % this.messages.length);
      }, this.delay);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
